import { TFunction } from 'i18next';
import { TQuizStep } from '@/shared/ui';
import FinalQuizStep from '../ui/FinalQuizStep';
import { IQuizForm } from './generateQuizResponse';

export const getQuizStepsData = (t: TFunction): TQuizStep<IQuizForm>[] => {
  const step1Options = t('mainPage.newCustomerForm.quiz.step1.options', {
    returnObjects: true,
  }) as string[];
  const step2Options = t('mainPage.newCustomerForm.quiz.step2.options', {
    returnObjects: true,
  }) as string[];
  const step3Options = t('mainPage.newCustomerForm.quiz.step3.options', {
    returnObjects: true,
  }) as string[];
  const step4Options = t('mainPage.newCustomerForm.quiz.step4.options', {
    returnObjects: true,
  }) as string[];
  const step5Options = t('mainPage.newCustomerForm.quiz.step5.options', {
    returnObjects: true,
  }) as string[];
  const step6Options = t('mainPage.newCustomerForm.quiz.step6.options', {
    returnObjects: true,
  }) as string[];

  const nextButton = t('mainPage.newCustomerForm.nextButton');

  return [
    {
      isDefaultQuizFormStep: true,
      stepData: {
        heading: t('mainPage.newCustomerForm.quiz.step1.heading'),
        options: {
          name: 'interestedSolutions',
          items: step1Options.map((label) => ({ label, value: label })),
          type: 'multiple',
        },
        input: {
          name: 'otherInterestedSolutions',
          placeholder: t('mainPage.newCustomerForm.quiz.step1.placeholder'),
        },
        buttonText: nextButton,
      },
    },
    {
      isDefaultQuizFormStep: true,
      stepData: {
        heading: t('mainPage.newCustomerForm.quiz.step2.heading'),
        options: {
          name: 'locationsCount',
          items: [
            { label: step2Options[0]!, value: '1' },
            { label: step2Options[1]!, value: '2-5' },
            { label: step2Options[2]!, value: '6-10' },
            { label: step2Options[3]!, value: '11+' },
          ],
          type: 'single',
        },
        buttonText: nextButton,
      },
    },
    {
      isDefaultQuizFormStep: true,
      stepData: {
        heading: t('mainPage.newCustomerForm.quiz.step3.heading'),
        options: {
          name: 'monthlyCustomers',
          items: [
            { label: step3Options[0]!, value: '<50' },
            { label: step3Options[1]!, value: '50-200' },
            { label: step3Options[2]!, value: '200-500' },
            { label: step3Options[3]!, value: '500+' },
          ],
          type: 'single',
        },
        buttonText: nextButton,
      },
    },
    {
      isDefaultQuizFormStep: true,
      stepData: {
        heading: t('mainPage.newCustomerForm.quiz.step4.heading'),
        options: {
          name: 'reviewPlatforms',
          items: step4Options.map((label) => ({
            label,
            value: label === 'Better Business Bureau (BBB)' ? 'BBB' : label,
          })),
          type: 'multiple',
          styles: {
            w: '46%',
            flexGrow: 1,
          },
        },
        input: {
          name: 'otherReviewPlatforms',
          placeholder: t('mainPage.newCustomerForm.quiz.step4.placeholder'),
        },
        buttonText: nextButton,
      },
    },
    {
      isDefaultQuizFormStep: true,
      stepData: {
        heading: t('mainPage.newCustomerForm.quiz.step5.heading'),
        options: {
          name: 'crmPlatforms',
          items: step5Options.map((label) => ({
            label,
            value: label === 'Monday.com' ? 'Monday' : label,
          })),
          type: 'multiple',
          styles: {
            w: '46%',
          },
        },
        input: {
          name: 'otherCrmPlatforms',
          placeholder: t('mainPage.newCustomerForm.quiz.step5.placeholder'),
        },
        buttonText: nextButton,
      },
    },
    {
      isDefaultQuizFormStep: true,
      stepData: {
        heading: t('mainPage.newCustomerForm.quiz.step6.heading'),
        options: {
          name: 'isUseReviewManagers',
          items: [
            { label: step6Options[0]!, value: 'true' },
            { label: step6Options[1]!, value: 'false' },
          ],
          type: 'single',
        },
        input: {
          name: 'otherReviewManagers',
          placeholder: t('mainPage.newCustomerForm.quiz.step6.placeholder'),
          requiredAnswer: 'true',
        },
        buttonText: t('mainPage.newCustomerForm.quiz.step6.buttonText'),
        buttonType: 'submit',
      },
    },
    {
      isDefaultQuizFormStep: false,
      CustomStepComponent: FinalQuizStep,
    },
  ];
};
